// OCR extraction.
//
// Calls the backend /caddiegames/extract-roster endpoint, which forwards
// the image to OpenAI gpt-4o vision and returns a structured player list.
// Backend handles the API key, prompt, and JSON sanitization — this is
// just the upload + parse.

import { ExtractedPlayer } from "./rosterMatching";

interface ExtractResponse {
  players?: ExtractedPlayer[];
  error?: string;
}

export async function extractFromImage(
  file: File,
): Promise<ExtractedPlayer[]> {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/caddiegames/extract-roster`,
    {
      method: "POST",
      credentials: "include",
      body: form,
    },
  );

  if (!res.ok) {
    let message = `Extraction failed (${res.status})`;
    try {
      const data: ExtractResponse = await res.json();
      if (data.error) message = data.error;
    } catch {
      // ignore — keep the default message
    }
    throw new Error(message);
  }

  const data: ExtractResponse = await res.json();
  return Array.isArray(data.players) ? data.players : [];
}
